import { Filter, FilterProps } from '@otp/ui';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getFilterConfig } from './config';
import { useQuery } from '@apollo/client';
import {
  WttpQuestionCategoriesDocument,
  WttpQuestionCategoriesQuery,
} from 'src/graphql/generated/graphql';

export const WttpQuestionnaireQuestionsFilter = (props: Omit<FilterProps, 'items'>) => {
  const { t } = useTranslation();

  const { data: categories } = useQuery<WttpQuestionCategoriesQuery>(
    WttpQuestionCategoriesDocument,
    {
      variables: {
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  const categoriesOptions = useMemo(
    () =>
      (categories?.wttpQuestionCategories?.records || []).map((category) => ({
        value: category.id,
        name: category.name ?? '',
      })) ?? [],
    [categories],
  );

  const filterConfig = getFilterConfig(categoriesOptions || [], { t });

  return (
    <Filter
      {...props}
      items={filterConfig}
      searchInputProps={{
        placeholder: t('wttp.questionnaire.filter.placeholder'),
      }}
    />
  );
};
